// extracted by mini-css-extract-plugin
module.exports = {"pill-container":"Pill_pill-container__iS1df","selected":"Pill_selected__emp6I"};